(function () {
  var setup = document.getElementById('fit-setup');
  if (!setup || !document.querySelector('.fit-upload-form')) return;
  var attempts = 0;
  var timer = setInterval(function () {
    var host = document.querySelector('.fit-upload-form shopify-forms-embed');
    var root = host && host.shadowRoot;
    var field = root && root.querySelector('textarea[name="custom#selected_setup"]');
    if (!field) { if (++attempts > 80) clearInterval(timer); return; }
    clearInterval(timer);
    function sync() {
      Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(field, setup.value);
      field.dispatchEvent(new Event('input', {bubbles:true}));
      field.dispatchEvent(new Event('change', {bubbles:true}));
    }
    if (!field.value) sync();
    if (field.value === setup.value) field.parentElement.hidden = true;
    setup.addEventListener('input', sync);
    field.addEventListener('input', function () {
      if (setup.value !== field.value) { setup.value = field.value; setup.dispatchEvent(new Event('input', {bubbles:true})); }
    });
    root.querySelectorAll('textarea[name]').forEach(function (textarea) {
      textarea.id = textarea.name;
      textarea.setAttribute('aria-labelledby', 'label-' + textarea.name);
    });
    var email = root.querySelector('#email');
    var name = root.querySelector('#first_name');
    var question = root.querySelector('textarea[name="custom#your_bike_question"]');
    if (email && name) {
      email.parentElement.classList.add('fit-email-field');
      name.parentElement.classList.add('fit-name-field');
      name.parentElement.before(email.parentElement);
      email.setAttribute('autocomplete', 'email');
      name.setAttribute('autocomplete', 'name');
    }
    if (question) question.placeholder = 'Bike make/model, wheel size, and what you’d like to check.';
    var style = document.createElement('style');
    style.textContent = `
      :host{--inline-container-max-width:100%!important;--forms-body-font:400 15px var(--sans-stack,Arial,sans-serif)!important;--forms-heading-font:500 22px var(--sans-stack,Arial,sans-serif)!important;--button-border-radius:999px!important;--container-text-alignment:left!important;--form-background-color:#fafaf6!important;--form-field-border-radius:6px!important;--app-embed-padding-x:0!important;--app-embed-padding-y:0!important}
      [hidden]{display:none!important}[class*="_formHeader_"]{display:none}
      form[data-testid="form"]{display:grid!important;grid-template-columns:1fr 1fr;gap:24px 18px!important}
      form[data-testid="form"]> *{grid-column:1 / -1;min-width:0}
      form[data-testid="form"]>.fit-email-field{grid-column:1}
      form[data-testid="form"]>.fit-name-field{grid-column:2}
      [class*="_formFieldContainer_"]{display:flex!important;flex-direction:column;gap:9px;box-shadow:none!important;background:transparent!important;padding:0!important}
      [class*="_formFieldContainer_"]>label{position:static!important;transform:none!important;order:-1;display:block!important;font-size:14px!important;line-height:1.4!important;color:#171915!important;margin:0!important;padding:0!important}
      label[for="email"]:after,label[for="custom#your_bike_question"]:after{content:' (required)';font-size:12px;color:#73766f}
      input:not([type="file"]),textarea{box-sizing:border-box!important;width:100%!important;min-height:48px;padding:13px 14px!important;border:1px solid #c5c7be!important;border-radius:6px!important;background:#fafaf6!important;box-shadow:none!important;font:400 15px/1.5 var(--sans-stack,Arial,sans-serif)!important;color:#171915!important}
      textarea{min-height:125px;resize:vertical}
      input:focus-visible,textarea:focus-visible,button:focus-visible{outline:2px solid #b52a20!important;outline-offset:3px}
      button[type="submit"]{min-height:48px;width:fit-content!important;padding:15px 26px!important;justify-self:start;font-weight:500!important}
      [class*="_formFieldContainer_"]::before{display:none!important}[class*="_formFieldContainer_"][hidden]{display:none!important}
      @media(max-width:700px){form[data-testid="form"]{grid-template-columns:1fr}form[data-testid="form"]>.fit-email-field,form[data-testid="form"]>.fit-name-field{grid-column:1} }
    `;
    root.appendChild(style);
  }, 250);
})();
